.hideOverflow {
    overflow: hidden;
  }